import { Organization, OrganizationMember } from '@prisma/client'
import { message } from 'antd'
import { useState } from 'react'
import { InputUploadItem } from '~/features/formConfiguration/client/components/CustomInputs/InputUpload'
import { Toolbox } from '~/plugins/toolbox/shared'
import { useUploadToAppSession } from '~/plugins/upload/client'
import { useSdk } from './useSdk'

type Options = {
  organization: Organization
  organizationMember: OrganizationMember
}

export const useUpload = ({ organization, organizationMember }: Options) => {
  const sdk = useSdk({ organizationMember })

  const uploadToAppSession = useUploadToAppSession()

  const [isLoading, setLoading] = useState(false)

  const uploadManyFiles = async (files: InputUploadItem[]) => {
    setLoading(true)

    for (const file of files) {
      try {
        const { url } = await uploadToAppSession.mutateAsync({
          appSessionId: organizationMember.appSessionId,
          file: file.file as File,
        })

        await sdk.createOneFile({
          url,
          name: file.name,
          mimetype: file.type,
        })
      } catch (error) {
        message.error(`Could not handle file "${file.name}"`)
        console.error('Unknown Error', error)
      }
    }

    setLoading(false)
  }

  const createOneFile = async () => {
    setLoading(true)

    try {
      const now = Toolbox.Date.getNow()
      const date = Toolbox.Date.toHumanDate(now)

      await sdk.createOneFile({
        name: `New document (${date})`,
        mimetype: 'text/plain',
        content: '',
      })
    } catch (error) {
      message.error(`Something went wrong`)
      console.error('Unknown Error', error)
    }

    setLoading(false)
  }

  return {
    isLoading: isLoading,
    uploadManyFiles,
    createOneFile,
  }
}
